import React from 'react';

import Link from 'next/link';

import { Button, primaryTheme } from '@repo/ui/components/Buttons';

import { getMediaCdnUrl } from 'global/prismicUtils';
import { FlexRow } from 'styles/layouts';

import { Wrapper, Image, Description } from './styles';

const ImageSlice = ({ slice }) => {
  return (
    <Wrapper>
      {slice.items?.map((item, index) => {
        // in case image url was not provided (blank image) don't render anything
        if (!item.image.url) {
          return null;
        }
        if (item.link.url) {
          return (
            <Link key={index} href={item.link.url}>
              <Image
                alt={item.image.alt}
                cursor="pointer"
                src={getMediaCdnUrl(item.image.url)}
              />
              {item.description && (
                <Description>{item.description}</Description>
              )}
              {!item.description && !!item.buttonLabel && (
                <FlexRow justifyContent="center" style={{ marginTop: '18px' }}>
                  <Button
                    height="40px"
                    label={item.buttonLabel}
                    theme={primaryTheme}
                    width="auto"
                  />
                </FlexRow>
              )}
            </Link>
          );
        }

        return (
          <div key={index}>
            <Image alt={item.image.alt} src={getMediaCdnUrl(item.image.url)} />
            {item.description && <Description>{item.description}</Description>}
          </div>
        );
      })}
    </Wrapper>
  );
};

export default ImageSlice;
